import { useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = ({ logo, propJustifyContent, propGap, onCampaignsClick }) => {
  const footerStyle = useMemo(() => {
    return {
      justifyContent: propJustifyContent,
      gap: propGap,
    };
  }, [propJustifyContent, propGap]);

  const navigate = useNavigate();

  const onEmailMarketingClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div
      className="self-stretch rounded-tl-none rounded-tr-61xl rounded-b-none bg-light overflow-hidden flex flex-row py-[120px] px-[185px] items-center justify-start gap-[90px] text-left text-base text-dark font-footnote md:flex-col"
      style={footerStyle}
    >
      <img className="relative w-[160.68px] h-10" alt="" src={logo} />
      <div className="w-[405px] overflow-hidden shrink-0 flex flex-row items-center justify-center gap-[32px] md:flex-col sm:flex-col">
        <a
          className="[text-decoration:none] relative tracking-[-0.2px] text-[inherit] cursor-pointer"
          onClick={onEmailMarketingClick}
        >
          Home
        </a>
        <Link
          className="cursor-pointer [text-decoration:none] relative tracking-[-0.2px] text-[inherit]"
          to="/about"
          onClick={onCampaignsClick}
        >
          About Us
        </Link>
        <a
          className="[text-decoration:none] relative tracking-[-0.2px] text-[inherit]"
          target="_blank"
        >
          Privacy Policy
        </a>
      </div>
      <div className="relative text-mini tracking-[-0.2px] font-dm-sans opacity-[0.5] mix-blend-normal">
        Copyright © 2023. Prairie. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
